import React from 'react';

export function Accordion({ title, children, defaultOpen = false, className = '' }) {
  return (
    <details className={`ds-accordion ${className}`.trim()} open={defaultOpen || undefined}>
      <summary className="ds-accordion__summary">{title}</summary>
      <div className="ds-accordion__body">{children}</div>
    </details>
  );
}

export default Accordion;
